// Akaru-inspired direction: arrive from bottom-left, leave toward top-right.
// The artwork, size and colors remain the AW Figma component's own states.
export function initMenuArrows({ gsap, motion, scope }) {
  const document=scope.document;
  const window=scope.ownerDocument.defaultView;
  const matchMedia=window.matchMedia.bind(window);
  const controls = [];
  document
    .querySelectorAll(".aw-menu__link:not([data-preview-state])")
    .forEach((link) => {
      const arrow = link.querySelector(".aw-menu__arrow");
      if (!arrow) return;
      let hovered = false;
      let shown = false;
      const selected = () => link.getAttribute("aria-current") === "page";
      const focused = () => link.matches(":focus-visible");

      const render = (visible, instant = false) => {
        if (instant || !motion.enabled) {
          gsap.killTweensOf(arrow);
          gsap.set(arrow, {
            xPercent: 0,
            yPercent: 0,
            opacity: visible ? 1 : 0,
          });
        } else if (visible !== shown) {
          gsap.killTweensOf(arrow);
          // Only reset a fully hidden arrow. Interrupted flights continue from
          // their current position instead of jumping to the starting corner.
          if (visible && Number(gsap.getProperty(arrow, "opacity")) < 0.001) {
            gsap.set(arrow, { xPercent: -100, yPercent: 100 });
          }
          gsap.to(arrow, {
            xPercent: visible ? 0 : 100,
            yPercent: visible ? 0 : -100,
            opacity: visible ? 1 : 0,
            duration: visible ? 0.42 : 0.3,
            ease: visible ? "power3.out" : "power2.in",
            overwrite: true,
          });
        }
        shown = visible;
      };
      const refresh = () => render(hovered || focused() || selected());
      const reset = () => {
        hovered = false;
        render(focused() || selected(), true);
      };

      reset();
      link.classList.add("has-arrow-motion");
      scope.on(link, "pointerenter", (event) => {
        if (event.pointerType === "touch") return;
        hovered = true;
        refresh();
      });
      scope.on(link, "pointerleave", () => {
        hovered = false;
        refresh();
      });
      scope.on(link, "pointercancel", reset);
      scope.on(link, "focus", refresh);
      scope.on(link, "blur", refresh);
      controls.push({
        link,
        reset,
        settle: () => render(hovered || focused() || selected(), true),
      });
    });
  scope.on(document, "aw:motionchange", () =>
    controls.forEach(({ settle }) => settle()));
  scope.onDispose(()=>controls.forEach(({link})=>link.classList.remove("has-arrow-motion")));
  return {
    reset(root) {
      controls.forEach((control) => {
        if (root.contains(control.link)) control.reset();
      });
    },
  };
}
